<template>
    <div class="vue-mobile-active-garage-block" :class="{'no-garage': hasActiveGarage === false}">
        <template v-if="hasActiveGarage === true">
                <h2 class="virtual-h4">
                    {{ yourCarProf }}<br>
                    <a :href="activeGarage.url">{{ activeGarage.title }}</a>
                </h2>

                <div class="info d-flex justify-content-between align-content-center mt-4">
                    <div class="contact">
                        <address class="mb-0">
                            <p>
                                {{ activeGarage.streetNumber }}<br>
                                {{ activeGarage.postalCodePlace }}<br>
                            </p>

                            <p class="mb-0">
                                <template v-if="this.parsedPhonenumber">
                                    <a :href="`tel:${ parsedPhonenumber }`">{{ activeGarage.tel }}</a><br>
                                </template>

                                Email: <a :href="`mailto:${activeGarage.email}`">{{ activeGarage.email }}</a>
                            </p>
                        </address>
                    </div>

                    <div class="klantenvertellen" v-if="hasKlantenvertellen">
                        {{ activeGarage.klantenvertellen.averageScore }}
                    </div>
                </div>

                <div class="mt-4">
                    <template v-if="hasPlannerUrl && !hideAppointment">
                        <a :href="`${activeGarage.url}/afspraak-maken`" class="btn-arrow">{{ makeAppointment }}</a>
                    </template>

                    <template v-if="!hasPlannerUrl && !hideAppointment">
                        <a :href="appointmentUrl" rel="noopener" oncontextmenu="return false;" class="btn-arrow webform-dialog webform-dialog-narrow button">{{ makeAppointment }}</a>
                    </template>

                    <a :href="`${activeGarage.url}/prijs-berekenen`" class="btn-arrow-inverse">{{ calculatePrice }}</a>
                </div>

                <hr class="divider">

                <a href="/vestigingen" class="cta-link">{{ selectDifferentLocation }}</a>
        </template>
    </div>
</template>

<script>
import ActiveGarageMixin from "../mixins/ActiveGarageMixin";

export default {
    name: "ActiveGarageBlock",

    mixins: [ActiveGarageMixin],

    data() {
        return {
            open: false,
            yourCarProf: window.Drupal.t('Uw CarProf'),
            sendAnEmail: window.Drupal.t('Stuur een e-mail'),
            makeAppointment: window.Drupal.t('Afspraak maken'),
            calculatePrice: window.Drupal.t('Prijs berekenen'),
            selectDifferentLocation: window.Drupal.t('Selecteer een andere vestiging'),
        }
    },
}
</script>
